import { useState } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import { useSelector, shallowEqual } from 'react-redux'
import classNames from 'classnames'
import BtnLink from '@/components/BtnLink'
import ParallaxImg from '@/components/ParallaxImg'
import { decodeEntities } from '@/utils/decodeEntities'
import style from './style'

const useStyles = createUseStyles(style)

const ServiceItem = ({
  item,
  reverseImage,
  orderedList,
  background,
}) => {
  const classes = useStyles()
  const [hover, setHover] = useState(false)

  const { mediaQueryKey, strings } = useSelector((state) => ({
    mediaQueryKey: state.mediaQuery.key,
    strings: state.language.string,
  }), shallowEqual)

  const handleMouseMove = (e) => {
    if (e.type === 'mouseenter' && !hover && mediaQueryKey > 1) setHover(true)
    if (e.type === 'mouseleave' && hover && mediaQueryKey > 1) setHover(false)
  }

  return (
    <div
      className={classNames({
        [classes.root]: true,
        [classes.rootReverse]: reverseImage,
        [classes.rootBackground]: background,
        serviceItem__root: true,
        [classes.hover]: hover,
        serviceItem__hover: hover,
      })}
    >
      <div
        className={`${classes.wrapper} serviceItem__wrapper`}
        onMouseEnter={(e) => handleMouseMove(e)}
        onMouseLeave={(e) => handleMouseMove(e)}
      >
        <div className={`${classes.image} serviceItem__image`}>
          {item.image && (
            <ParallaxImg
              img={item.image}
              title={item.title}
            />
          )}
        </div>
        <div className={`${classes.info} serviceItem__info`}>
          {item.cat && (
            <div
              className={`${classes.category} serviceItem__category`}
              dangerouslySetInnerHTML={{ __html: item.cat }}
            />
          )}
          {item.title && (
            <div
              className={`${classes.title} serviceItem__title`}
              dangerouslySetInnerHTML={{ __html: `${orderedList ? `${Number(item.id) + 1}. ` : ''}${decodeEntities(item.title)}` }}
            />
          )}
          {item.description && (
            <div
              className={`${classes.description} serviceItem__description`}
              dangerouslySetInnerHTML={{ __html: decodeEntities(item.description) }}
            />
          )}
          {item.link && (
            <BtnLink
              className={`${classes.btn} serviceItem__btn`}
              link={item.link}
              label={strings.discover_label}
              theme="light"
              fill
            />
          )}
        </div>
      </div>
    </div>
  )
}

ServiceItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    image: PropTypes.string,
  }).isRequired,
  background: PropTypes.bool,
}

ServiceItem.defaultProps = {
  background: true,
}

export default ServiceItem
